var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-flyout",
      style: _vm.panelStyle,
      on: {
        mouseenter: function($event) {
          return _vm.$emit("mouseenter")
        },
        mouseleave: function($event) {
          return _vm.$emit("mouseleave")
        }
      }
    },
    [
      _c("div", { staticClass: "nav-flyout__title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._l(_vm.items, function(item) {
        return _c(
          "button",
          {
            key: item.key,
            staticClass: "nav-flyout__item",
            class: { "nav-flyout__item--active": _vm.isActive(item) },
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("select", item)
              }
            }
          },
          [_vm._v(" " + _vm._s(item.label) + " ")]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }